import { React, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import '../App.css';

// components
import Sidebar from "../components/CMS/Sidebar/Sidebar.js";
import HeaderWithoutStats from "../components/CMS/Headers/HeaderWithoutStats.js";
import Loader from "../components/CMS/Loader/Loader.js";

// dnd
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

export default function Admin() {

  const [dragDropList, setDragDropList] = useState([]);
  const [isImgOrderUpdated, setIsImgOrderUpdated] = useState(false);

  const onDragComplete = (result) => {

    setIsImgOrderUpdated(true);
    if (!result.destination) return;

    const arr = [...dragDropList];
    //Changing the position of Array element
    let removedItem = arr.splice(result.source.index, 1)[0];
    arr.splice(result.destination.index, 0, removedItem);

    for (var i = 0; i < arr.length; i++) {
      arr[i].newOrder = i;
    }

    //Updating the list
    setDragDropList(arr);
    console.log(arr);
  };

  const dataSample = [
    {
      "id": null,
      "projectId": 1001,
      "projectDesc": "fox jumps over the lazy dogTh",
      "projectBuildingType": " ",
      "projectCoverImg": "https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350",
      "projectDistrict": "YMT ",
      "projectArea": "HK",
      "projectAddress": "502 Foxrun Street Park Ridge, IL 60068",
      "projectBuildingStyle": null,
      "projectHouseSize": "-318144416.422",
      "projectHouseName": "Bertram",
      "projectBuildTime": null,
      "creationTime": null,
      "hasFeatured": 0
    }
  ]

  const [data, setData] = useState(dataSample);
  const [loading, setLoading] = useState(true);
  const [selectDate, setSelectDate] = useState(new Date());
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { projectID } = useParams();
  const [files, setFile] = useState([]);
  const [message, setMessage] = useState();
  const [projectImgs, setProjectImgs] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const token = localStorage.getItem("token");
  var projectCoverImgUrl = "";
  var projectImgUrl = "";

  function validateLogin() {
    fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/validate', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
    })
      .then(response => {
        if (response.status === 200) {
          // console.log("is true")
        } else {

          window.location.href = '/cms/admin/login';
        }
      })
      .catch((e) => {
        window.location.href = '/cms/admin/login';
      });
  }

  const handleFile = (e) => {
    setMessage("");
    let file = e.target.files;

    for (let i = 0; i < file.length; i++) {
      const fileType = file[i]['type'];
      const validImageTypes = ['image/jpeg', 'image/png'];
      if (validImageTypes.includes(fileType)) {
        setFile(files => [...files, file[i]]);
      } else {
        setMessage("only images accepted");
      }

    }
  };

  const removeImage = (i) => {
    setFile(files.filter(x => x.name !== i));
  }

  async function removeImages() {

    var selectedImages = document.getElementById('selectedImages');
    var chks = selectedImages.querySelectorAll('input[type="checkbox"]');
    var param = [];
    console.log(selectedImages);
    for (var i = 0; i < chks.length; i++) {
      console.log(chks[i].checked);
      if (chks[i].checked) {
        param.push({ "projectId": parseInt(projectID), "projectImageUrl": chks[i].value });
      }
    }

    console.log(JSON.stringify(param))
    console.log(param.length)

    if (param.length <= 0) {
      alert("請最少選擇一張圖片！")
    } else {
      var confirmRemoveImgUrl = window.confirm('你確定刪除這張圖片嗎?');

      if (confirmRemoveImgUrl) {
        await fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/deleteProjectImages', {
          method: "POST",
          body: JSON.stringify(param),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
          },
        }).then((response) => response.json())
          .then((data) => {
            alert("刪除成功!")
            window.location.reload();
          })
      }
    }
  }
  const coverImg_changed = (e) => {
    var src = URL.createObjectURL(e.target.files[0]);
    // console.log(src);
    document.getElementById("coverImg").setAttribute('src', src);
  }

  async function getData() {
    fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/' + projectID)
      .then(response => response.json())
      .then((usefulData) => {
        // console.log(usefulData.data);
        setLoading(false);
        setData(usefulData.data);
        setSelectDate(new Date(usefulData.data.projectBuildTime))
      })
      .catch((e) => {
        console.error(`An error occurred: ${e}`)
      });

    console.log(isImgOrderUpdated);

    fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/projects/' + projectID + '/img')
      .then(response => response.json())
      .then((usefulData) => {
        console.log(usefulData.data);
        setProjectImgs(usefulData.data.projectImgUrls)

        var previewImgList = [];
        for (let i = 0; i < usefulData.data.projectImgUrls.length; i++) {
          previewImgList.push({ "id": i + '', "projectId": parseInt(projectID), "projectImageUrl": usefulData.data.projectImgUrls[i], "newOrder": i });
        }
        setDragDropList(previewImgList);
        console.log(previewImgList);

      })
      .catch((e) => {
        console.error(`An error occurred: ${e}`)
      });

  }

  async function uploadProjectImgToImgur(file) {
    // console.log(file);
    const formData = new FormData();
    formData.append("file", file);
    await fetch(process.env.REACT_APP_ESERVICE_HK_API_LINK, {
      method: "POST",
      body: formData,
    }).then((response) => response.json())
      .then((data) => {
        console.log("data " + data)
        projectImgUrl = data.url;
        console.log("projectImgUrl " + projectImgUrl)
      })
  }

  useEffect(() => {
    validateLogin();
    getData();
  }, []);

  async function onSubmit() {
    setIsUploading(true);
    var projectDesc = document.getElementById("projectDesc");
    var projectCoverImg = document.getElementById("projectCoverImg").files[0];
    var projectAddress = document.getElementById("projectAddress");
    var projectArea = document.getElementById("projectArea");
    var projectDistrict = document.getElementById("projectDistrict");
    var projectHouseName = document.getElementById("projectHouseName");
    var projectBuildingType = document.getElementById("projectBuildingType");
    var projectHousingType = document.getElementById("projectHousingType");
    var featured = document.querySelector('input[name="featuredValue"]:checked');;
    var projectHouseSize = document.getElementById("projectHouseSize");
    var imgUrls = [];

    if (projectDesc.value === "" || projectHouseName.value === "" ||
      projectDistrict.value === "" || projectHouseSize.value === "") {
      alert("請填寫所有資料！")
      setIsUploading(false);
    } else {

      if (projectCoverImg !== undefined) {
        await uploadProjectImgToImgur(projectCoverImg);
        projectCoverImgUrl = projectImgUrl;
      } else {
        projectCoverImgUrl = data.projectCoverImg;
      }

      const newProject = {
        projectId: parseInt(projectID),
        projectDescription: projectDesc.value,
        projectBuildingType: projectBuildingType.value,
        projectCoverImg: projectCoverImgUrl,
        projectDistrict: projectDistrict.value,
        projectArea: projectArea.value,
        projectAddress: projectAddress.value,
        projectBuildingStyle: projectHousingType.value, // remarks
        projectBuildTime: format(selectDate, "yyyy/MM/dd"),
        projectHouseSize: projectHouseSize.value,
        projectHouseName: projectHouseName.value,
        hasFeatured: featured.value
      };

      console.log(newProject);
      console.log(JSON.stringify(newProject));
      // console.log(files)

      for (let i = 0; i < files.length; i++) {
        console.log("files " + i + " " + projectImgUrl)
        await uploadProjectImgToImgur(files[i]);
        if (projectImgUrl) {
          const obj = { "projectId": parseInt(projectID), "projectImageUrl": projectImgUrl }
          imgUrls.push(obj);
        }
        console.log("files " + i + " " + projectImgUrl);
      }
      // if all files uploaded to imgur
      console.log("imgUrls.length " + imgUrls.length);
      console.log("files.length " + files.length);
      if (imgUrls.length === files.length) {
        await fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/updateProject', {
          method: "POST",
          body: JSON.stringify(newProject),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token,
          },
        }).then(response => response.json())
          .then((data) => {
            // console.log("result: " + data.data);
            if (files.length !== 0) {
              fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/createProjectImages', {
                method: "POST",
                body: JSON.stringify(imgUrls),
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token,
                },
              }).then(response => response.json())
                .then((data) => {
                  // console.log("result: " + data);
                  if (data.status === 200) {
                    setShowSuccessModal(true);
                    setIsUploading(false);
                  } else {
                    alert("上載失敗,請重新嘗試")
                    setIsUploading(false);
                  }
                });
            } else {

              // if img order is changed, call update project img api
              if (isImgOrderUpdated) {
                console.log(JSON.stringify(dragDropList))
                fetch(process.env.REACT_APP_API_BASE_LINK + '/v1/fookchong/cms/updateProjectImages', {
                  method: "POST",
                  body: JSON.stringify(dragDropList),
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                  },
                }).then(response => response.json())
                  .then((data) => {
                    console.log(data)
                    if (data.code === 200) {
                      setShowSuccessModal(true);
                      setIsUploading(false);
                    } else {
                      alert("上載失敗,請重新嘗試")
                      setIsUploading(false);
                    }

                  });

              } else {
                setShowSuccessModal(true);
                setIsUploading(false);
              }
            }
          });
      } else {
        alert("上載失敗,請重新嘗試")
        setIsUploading(false);
      }
    }
  }

  return (
    <>
      <Sidebar />
      <div>
        <div className="relative md:ml-64 bg-blueGray-100">
          {
            (isUploading === true)
              ? <div className="absolute bg-white bg-opacity-60 z-10 h-full w-full flex items-center justify-center">
                <div className="flex items-center">
                  <svg className="animate-spin h-10 w-10 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>

                </div>
              </div>
              : <div className="hidden absolute bg-white bg-opacity-60 z-10 h-full w-full flex items-center justify-center">
                <div className="flex items-center">
                  <svg className="animate-spin h-10 w-10 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                    </path>
                  </svg>

                </div>
              </div>
          }
          <nav className="absolute top-0 left-0 w-full z-10 bg-transparent md:flex-row md:flex-nowrap md:justify-start flex items-center p-4">
            <div className="w-full mx-autp items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
              {/* Brand */}
              <div
                className="text-white text-xl uppercase lg:inline-block font-semibold"
              >
                項目管理
              </div>

            </div>
          </nav>
          {/* Header */}
          <HeaderWithoutStats />
          {
            (loading === true)
              ? <Loader />
              : <div className="px-4 md:px-10 mt-4">

                <div className="uppercase font-semibold text-lg mb-4">項目 ID: {data.projectId}</div>
                <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
                  <div className="">
                    <figure className="w-full mt-4">
                      <img id="coverImg" className="w-full h-64 rounded-lg " src={data.projectCoverImg} alt="image description"></img>
                      <figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">項目封面圖片</figcaption>
                      <input onChange={coverImg_changed} id="projectCoverImg" type="file" className="focus:outline-none" name="projectCoverImg" />
                    </figure>
                  </div>

                  <div className="lg:col-span-2">
                    <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-4">
                      <div className="md:col-span-5 ">
                        <label htmlFor="projectDesc" className="uppercase font-semibold">項目描述</label>
                        <textarea id="projectDesc"
                          rows="4"
                          defaultValue={data.projectDesc || ''}
                          className="mt-1 resize-none block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-gray-500 focus:ring-blue-500 focus:border--500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder=""></textarea>
                      </div>

                      <div className="md:col-span-5">
                        <label htmlFor="projectAddress" className="uppercase font-semibold">地址 (Optional)</label>
                        <input type="text" name="projectAddress" id="projectAddress" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={data.projectAddress || ''} />
                      </div>

                      <div className="md:col-span-4">
                        <label htmlFor="projectHouseName" className="uppercase font-semibold">住宅名稱</label>
                        <input type="text" name="projectHouseName" id="projectHouseName" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={data.projectHouseName || ''} />
                      </div>
                      <div className="md:col-span-1 text-left">
                        <label htmlFor="projectBuildTime" className="uppercase font-semibold">裝修日期</label>
                        <div className="h-10 flex mt-1" >
                          <DatePicker
                            selected={selectDate}
                            showYearDropdown
                            showMonthDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                            dateFormat="yyyy/MM/dd"
                            onChange={(date) => setSelectDate(date)
                            } />

                        </div>
                      </div>

                      <div className="md:col-span-2">
                        <label htmlFor="projectArea" className="uppercase font-semibold">區域</label>
                        <div className="relative">
                          <select defaultValue={data.projectArea} name="projectArea" id="projectArea" className="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded">
                            <option value="HK">香港</option>
                            <option value="KL">九龍</option>
                            <option value="NT">新界</option>
                          </select>
                          <div className="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">

                          </div>
                        </div>
                      </div>

                      <div className="md:col-span-2">
                        <label htmlFor="projectDistrict" className="uppercase font-semibold">住宅地區</label>
                        <div className="h-10 bg-gray-50 flex border border-gray-200 rounded items-center mt-1">
                          <input type="text" name="projectDistrict" id="projectDistrict" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={data.projectDistrict || ''} />

                        </div>
                      </div>
                      <div className="md:col-span-1">
                        <label htmlFor="style" className="uppercase font-semibold">樓宇類型</label>
                        <div className="relative">
                          <select defaultValue={data.projectBuildingType} name="projectBuildingType" id="projectBuildingType" className="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded">
                            <option value="Public">公屋</option>
                            <option value="Estate">居屋</option>
                            <option value="Private">私樓</option>
                            <option value="Others">其他</option>
                          </select>
                          <div className="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                          </div>
                        </div>

                      </div>
                      <div className="md:col-span-2 text-left">
                        <label htmlFor="style" className="uppercase font-semibold">建築風格</label>
                        <div className="relative">
                          {/* remarks */}
                          <select defaultValue={data.projectBuildingStyle} name="projectHousingType" id="projectHousingType" className="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded">
                            <option value="Y2">Y2型</option>
                            <option value="Y3">Y3型</option>
                            <option value="Y4">Y4型</option>
                            <option value="NCB">新十字型</option>
                            <option value="CB">康和式</option>
                            <option value="HR">和諧式</option>
                            <option value="LB">相連長型</option>
                            <option value="OS">長型或新長型</option>
                            <option value="SORDHB">單或雙工字型</option>
                            <option value="TT">雙塔式</option>
                            <option value="NSBD">非標準型</option>
                            <option value="Others">其他</option>

                          </select>

                        </div>
                      </div>

                      <div className="md:col-span-2 text-left">
                        <label htmlFor="district" className="uppercase font-semibold">精選</label>
                        <div className="flex items-center pl-4 rounded border border-gray-700">
                          <input defaultChecked={data.hasFeatured === 1} id="featured" type="radio" value="1" name="featuredValue" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 "></input>
                          <label htmlFor="featured" className="py-4 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">精選</label>
                          <input defaultChecked={data.hasFeatured === 0} id="notFeatured" type="radio" value="0" name="featuredValue" className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 "></input>
                          <label htmlFor="notFeatured" className="py-4 ml-2 w-full text-sm font-medium text-gray-900 dark:text-gray-300">非精選</label>
                        </div>

                      </div>

                      <div className="md:col-span-1 text-left">
                        <label htmlFor="projectHouseSize" className="uppercase font-semibold">住宅尺寸</label>
                        <div className="h-10 bg-gray-50 flex border border-gray-200 rounded items-center mt-1">
                          <input type="number" name="projectHouseSize" id="projectHouseSize" className="h-12 border mt-1 rounded px-4 w-full" defaultValue={data.projectHouseSize} />

                        </div>
                      </div>

                      <div className="md:col-span-5 uppercase font-semibold">
                        <label>現有項目圖片</label>
                        <div className="h-36 overflow-y-scroll flex flex-wrap gap-2 mt-2">

                          <div className="md:col-span-5 dndContainer">
                            <div className="">
                              <form id="selectedImages">
                                <DragDropContext onDragEnd={onDragComplete}>
                                  <Droppable droppableId="drag-drop-list" direction="horizontal">
                                    {(provided, snapshot) => (
                                      <div
                                        className="drag-drop-list-container"
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                      >
                                        {dragDropList.map((item, index) => (
                                          <Draggable
                                            key={item.id}
                                            draggableId={item.projectImageUrl}
                                            index={index}
                                          >
                                            {(provided) => (
                                              <div
                                                className="item-card"
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                              >
                                                <div className="overflow-hidden relative">
                                                  <div className="flex items-right absolute z-10 mt-1 ml-14 ">

                                                    <input type="checkbox" value={item.projectImageUrl} className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded" />

                                                  </div>
                                                  <img className="h-20 w-20 rounded-md" src={item.projectImageUrl} />
                                                </div>
                                              </div>
                                            )}
                                          </Draggable>
                                        ))}
                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </DragDropContext>
                              </form>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div className="md:col-span-5 text-right">
                        <div className="inline-flex items-end">
                          <button className="bg-red-500 text-white active:bg-red-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={() => removeImages()}
                          >
                            刪除選擇圖片
                          </button>
                        </div>
                      </div>

                      <div className="md:col-span-5 uppercase font-semibold">
                        <label>項目圖片</label>
                        <div className="rounded-lg shadow-xl bg-gray-50 md:w-1/2 w-[360px]">
                          <div className="m-4">
                            <span className="flex justify-center items-center text-[12px] mb-1 text-red-500">{message}</span>
                            <div className="flex items-center justify-center w-full">
                              <label className="flex cursor-pointer flex-col w-full h-32 border-2 rounded-md border-dashed hover:bg-gray-100 hover:border-gray-300">
                                <div className="flex flex-col items-center justify-center pt-7">
                                  <svg xmlns="http://www.w3.org/2000/svg"
                                    className="w-12 h-12 text-gray-400 group-hover:text-gray-600" viewBox="0 0 20 20"
                                    fill="currentColor">
                                    <path fillRule="evenodd"
                                      d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                                      clipRule="evenodd" />
                                  </svg>
                                  <p className="pt-1 text-sm tracking-wider text-gray-400 group-hover:text-gray-600">
                                    選擇一/多張照片</p>
                                </div>
                                <input type="file" onChange={handleFile} accept=".png, .jpg, .jpeg" className="opacity-0" multiple="multiple" name="files[]" />
                              </label>
                            </div>
                            <div className="scrollbar-thin scrollbar-thumb-blue-700 scrollbar-track-blue-300 h-32 overflow-y-scroll flex flex-wrap gap-2 mt-2">

                              {files.map((file, key) => {
                                return (
                                  <div key={key} className="overflow-hidden relative">
                                    <i onClick={() => { removeImage(file.name) }} className="fa fa-times absolute right-1 hover:text-gray-400 cursor-pointer"></i>
                                    <img className="h-20 w-20 rounded-md" src={URL.createObjectURL(file)} />
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        </div>
                      </div>


                      <div className="md:col-span-5 text-right">
                        <div className="inline-flex items-end">
                          <button className="bg-indigo-500 text-white active:bg-indigo-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                            type="button"
                            onClick={() => onSubmit()}
                          >
                            更新
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>

                  {showSuccessModal ? (
                    <>
                      <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                      >
                        <div className="relative w-auto ">
                          {/*content*/}
                          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                            <div className="flex items-start justify-between p-2">

                              <button type="button" className="focus:outline-none text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                onClick={() => {
                                  setShowSuccessModal(false);
                                  window.location.reload();
                                }}
                              >
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                              </button>
                            </div>

                            {/*body*/}
                            <div className="px-8 ">

                              <div className="mb-4 sm:flex">
                                <div className="flex items-center justify-center flex-none w-12 h-12 mx-auto bg-green-200 rounded-full">
                                  <svg className="w-6 h-6 fill-current text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z" /></svg>
                                </div>
                                <div className="text-center sm:ml-4 sm:text-left">
                                  <h5 className="mt-2 text-lg font-medium text-gray-800">
                                    成功更新項目!
                                  </h5>

                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                  ) : null}
                </div>
              </div>
          }
        </div>
      </div>
    </>
  );
}
